import { PropsWithChildren } from 'react';
import { useFeatureFlag } from './hooks';
import { FlagsTypes } from './types';

type Props = PropsWithChildren<{ flag: keyof FlagsTypes }>;

export function FeatureFlagWrapper({
  children,
  flag
}: Props): JSX.Element | null {
  const isFlagsEnable = useFeatureFlag(flag);
  if (!isFlagsEnable) {
    return null;
  }
  return <>{children}</>;
}
